import React from 'react';
import { PollUiComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import VyPoll from '../../../../common/Poll/Poll';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';

const Poll = ({ uiComponent }: UiComponentElementInterface<PollUiComponentInterface>) => {
  return (
    <div
      className={`[&_p]:text-lg w-full relative py-5`}
      style={{
        color: uiComponent?.styling?.textColor || '#000',
      }}>
      <TitleAndDescription component={uiComponent!} />
      <VyPoll
        allowUnregistered={uiComponent?.allowUnregistered}
        backgroundColor={uiComponent?.customStyling?.backgroundColor}
        textColor={uiComponent?.customStyling?.textColor}
      />
    </div>
  );
};

export default Poll;
